// chat/chat.store.ts

import { create } from "zustand";
import { ChatMessage } from "../types/chat.types";
import { CHAT_MOCK_RESPONSES } from "../mock/chat.mock";

 

interface ChatState {
  messages: ChatMessage[];
  loading: boolean;
  askQuestion: (question: string) => Promise<void>;
  reset: () => void;
}

export const useChatStore = create<ChatState>((set) => ({
  messages: [],
  loading: false,

  askQuestion: async (question: string) => {
    const userMessage: ChatMessage = {
      id: crypto.randomUUID(),
      role: "user",
      text: question,
    };

    set((state) => ({
      messages: [...state.messages, userMessage],
      loading: true,
    }));

    // ⏳ simulación API
    await new Promise((res) => setTimeout(res, 1000));

    const assistantMessage: ChatMessage = {
      id: crypto.randomUUID(),
      role: "assistant",
      text:
        CHAT_MOCK_RESPONSES[question] ??
        "No tengo una respuesta para esa consulta aún.",
    };

    set((state) => ({
      messages: [...state.messages, assistantMessage],
      loading: false,
    }));

    /*
      🔮 FUTURO (API REAL)
      const response = await api.post("/chat", { question })
      set(...)
    */
  },

  reset: () => set({ messages: [], loading: false }),
}));
